import React, { useEffect, useState } from 'react';

import Header from '../../hoc/Layout/Header';
import NoMailAccessIcon from '../../assets/noMailAccessPage.svg';
import AppLoader from '../modules/FullPageLoader/AppLoader';

const NoMailAccessPage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <div>
      <div
        style={{
          marginTop: '130px',
          marginInline: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {loading && <AppLoader />}
        <div style={{ height: '352px', display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '20px' }}>
          <img style={{ width: '300px', height: '300px' }} src={NoMailAccessIcon} alt="no access page" />
          <div style={{ fontWeight: 500, fontSize: '30px' }}>Oops.. You don't have access for this content</div>
        </div>
      </div>
    </div>
  );
};

export default NoMailAccessPage;
